import { createFAsomeStore } from '@apia/dom-store';
import { useMemo } from 'react';
import { getInitialState, getDistinctors, keysMakers } from './common';
import { operations } from './operations';
import { TListbox } from './ListboxContext';

export function useStore(
  storeId: string,
  {
    allowMultipleCharacterSearch,
    allowSelection,
    allowSingleCharacterSearch,
    isMultipleSelection,
    searchFunction,
    showSearchbox,
    startsWithFunction,
  }: TListbox,
) {
  return useMemo(() => {
    const newStore = createFAsomeStore({
      initialState: getInitialState({
        allowSelection: allowSelection ?? true,
        allowMultipleCharacterSearch:
          (allowMultipleCharacterSearch ?? true) && !showSearchbox,
        allowSingleCharacterSearch:
          (allowSingleCharacterSearch ?? true) && !showSearchbox,
        id: storeId,
        isMultipleSelection: !!isMultipleSelection,
        searchFunction,
        showSearchbox: showSearchbox ?? false,
        startsWithFunction,
      }),
      operations,
      distinctors: getDistinctors(storeId),
      keysMakers,
    });

    return newStore;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
